import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { EC } from "../../utils/const/ecommerce-colors-const";
import { toImageSrc } from "../../utils/ecommerce/svg-image-src";

export default function CategoryCard({ category, active = false, onClick }) {
    const { t } = useTranslation();
    const label = t(`${category.descripcion}`);

    useEffect(() => {
        // console.log("category");
        // console.log(category);
    }, [category]);

    return (
        <button
            type="button"
            onClick={() => onClick?.(category)}
            className={`group flex shrink-0 flex-col items-center gap-2 rounded-2xl border p-3 transition sm:p-4 ${active ? EC.category.active : EC.category.inactive
                }`}
            style={{ minWidth: "5.5rem", maxWidth: "7rem" }}
            aria-pressed={active}
        >
            <div className="relative h-14 w-14 overflow-hidden rounded-xl bg-slate-100 sm:h-16 sm:w-16">
                <img
                    src={toImageSrc(category.svg ?? category.image)}
                    alt={category.descripcion}
                    className="h-full w-full object-cover"
                    loading="lazy"
                />
                {/* <span
                    className="absolute inset-0 flex items-center justify-center text-2xl sm:text-3xl"
                    aria-hidden
                >
                    {category.icon}
                </span> */}
            </div>
            <span
                className={`line-clamp-2 text-center text-xs font-semibold leading-tight sm:text-sm ${active ? EC.category.labelActive : EC.category.labelInactive
                    }`}
            >
                {label}
            </span>
        </button>
    );
}
